import React from "react";
import styles from "./lessonSelector.module.css";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { Link } from "@reach/router";

export default function LessonSelector({ lessons, currLesson }) {
  const currLessonIndex = lessons.indexOf(currLesson);
  const lastLessonIndex = lessons.length - 1;
  const isLastLesson = currLessonIndex === lastLessonIndex;
  const isFirstLesson = currLessonIndex === 0;

  const prevLessonIndex = isFirstLesson ? lastLessonIndex : currLessonIndex - 1;
  const nextLessonIndex = isLastLesson ? 0 : currLessonIndex + 1;

  const prevLesson = lessons[prevLessonIndex];
  const nextLesson = lessons[nextLessonIndex];

  return (
    <div className={styles.lessonSelectorOuter}>
      <div className={styles.prevNextButtons}>
        <Link className={styles.navButt} to={`/${prevLesson.id}`}>
          <AiOutlineArrowLeft />
          <p>Walk back</p>
        </Link>
        <Link className={styles.navButt} to={`/${nextLesson.id}`}>
          <p>Walk on</p>
          <AiOutlineArrowRight />
        </Link>
      </div>
    </div>
  );
}
